import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, signal } from '@angular/core';

import { scrollToTop } from '../utilities/window-utilities';

@Component({
  selector: 'hsc-back-to-top',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    @if (showBackToTop()) {
      <div class="fixed right-4 bottom-4 z-50" style="text-align: right">
        <bolt-button color="vibrantBlue" type="solid" iconleft="arrow-up" (click)="scrollToTop()"
          >Back to Top</bolt-button
        >
      </div>
    }
  `,
})
export class BackToTop {
  scrollPosition = 0;
  readonly showBackToTop = signal(false);
  readonly scrollToTop = scrollToTop;

  @HostListener('window:scroll')
  onScroll() {
    this.scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.showBackToTop.set(this.scrollPosition > 400);
  }
}
